(() => {
  "use strict";
  const forms = document.querySelectorAll(".needs-validation");
  const formsSubmit = document.querySelectorAll(".btn-submit");

  Array.from(formsSubmit).forEach((button) => {
    button.addEventListener(
      "click",
      (event) => {
        const form = button.closest("form");
        if (form && !form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }

        if (form) {
          form.classList.add("was-validated");
        }
      },
      false
    );
  });

  
})();
